import type { ReactNode } from 'react';
import { Card, CardBody } from '@nextui-org/react';
import { Icon } from '@iconify/react';

export type KpiTone = 'default' | 'success' | 'warning' | 'danger';

const TONE_CLASS: Record<KpiTone, string> = {
  default: 'text-foreground',
  success: 'text-success-600',
  warning: 'text-warning-600',
  danger: 'text-danger-600',
};

// Indicador: etiqueta en mayúsculas chica, valor grande y un detalle opcional.
// Se usan en grilla (grid-cols-2 md:grid-cols-4). Ver design.md › Cards.
const KpiCard = ({
  label,
  value,
  detail,
  icon,
  tone = 'default',
}: {
  label: string;
  value: ReactNode;
  detail?: ReactNode;
  icon?: string;
  tone?: KpiTone;
}) => (
  <Card shadow='sm'>
    <CardBody className='gap-1 p-4'>
      <div className='flex items-center justify-between gap-2'>
        <span className='text-xs uppercase tracking-wide text-default-500'>
          {label}
        </span>
        {icon ? <Icon icon={icon} className='text-default-400' width={18} /> : null}
      </div>
      <span className={`text-2xl font-semibold ${TONE_CLASS[tone]}`}>{value}</span>
      {detail ? <span className='text-xs text-default-500'>{detail}</span> : null}
    </CardBody>
  </Card>
);

export default KpiCard;
